import {gameStatusChangedTemplateAnimationSetModel} from "../../templates/game-status-changed-template-animation-set-model";

export class MatchBreakTimeEndedAnimationSetModel extends gameStatusChangedTemplateAnimationSetModel {}